export var ActivityStatusStatus;
(function (ActivityStatusStatus) {
    /** Insufficient permissions to get the status. */
    ActivityStatusStatus["UNKNOWN"] = "UNKNOWN";
    /** Member can write forum posts and blog comments. */
    ActivityStatusStatus["ACTIVE"] = "ACTIVE";
    /** Member can't write forum posts or blog comments. */
    ActivityStatusStatus["MUTED"] = "MUTED";
})(ActivityStatusStatus || (ActivityStatusStatus = {}));
export var PrivacyStatusStatus;
(function (PrivacyStatusStatus) {
    /** Insufficient permissions to get the status. */
    PrivacyStatusStatus["UNKNOWN"] = "UNKNOWN";
    /** Member is hidden from site visitors and other site members. Member is returned only to site contributors and apps with the appropriate permissions. */
    PrivacyStatusStatus["PRIVATE"] = "PRIVATE";
    /** Member is visible to everyone. */
    PrivacyStatusStatus["PUBLIC"] = "PUBLIC";
})(PrivacyStatusStatus || (PrivacyStatusStatus = {}));
export var Status;
(function (Status) {
    /** Insufficient permissions to get the status. */
    Status["UNKNOWN"] = "UNKNOWN";
    /** Member created and is waiting for approval by site owner. */
    Status["PENDING"] = "PENDING";
    /** Member can log in to the site. */
    Status["APPROVED"] = "APPROVED";
    /** Member is blocked and can't log in to the site. */
    Status["BLOCKED"] = "BLOCKED";
    /** Member is a [guest author](https://support.wix.com/en/article/wix-blog-adding-guest-authors-to-your-blog) for the site blog and can't log in to the site. */
    Status["OFFLINE"] = "OFFLINE";
})(Status || (Status = {}));
export var ModerationStatusStatus;
(function (ModerationStatusStatus) {
    ModerationStatusStatus["UNKNOWN"] = "UNKNOWN";
    ModerationStatusStatus["APPROVED"] = "APPROVED";
    ModerationStatusStatus["REJECTED"] = "REJECTED";
})(ModerationStatusStatus || (ModerationStatusStatus = {}));
export var FeedType;
(function (FeedType) {
    FeedType["UNKNOWN_FEED_TYPE"] = "UNKNOWN_FEED_TYPE";
    FeedType["ALL_POSTS"] = "ALL_POSTS";
    FeedType["CATEGORY"] = "CATEGORY";
    FeedType["TAG"] = "TAG";
    FeedType["HASHTAG"] = "HASHTAG";
    FeedType["ARCHIVE"] = "ARCHIVE";
    FeedType["POST_LIST_WIDGET"] = "POST_LIST_WIDGET";
})(FeedType || (FeedType = {}));
//# sourceMappingURL=types.impl.js.map